const styles = {
  link: {
    textUnderlineOffset: "5px",
  },
  header: { fontSize: { xs: 20, md: 30 } },
  limitedTime: {
    mt: -2,
  },
};

export default styles;
